/* eslint-disable */ import { memoEval, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const lynxProfessionalOutdoorRefrigeratorW24Components = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'default', true).withEntity('LynxProfessionalOutdoorRefrigeratorW24').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'REFRIGERATOR_LN24REF',
            dimensionUnit: 'inch'
        })))
];

//# sourceMappingURL=lynx-professional-outdoor-refrigerator-w-24.js.map